import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.hostess.winloses;

export const hostessWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
